import React from "react";
import Typography from "@mui/material/Typography";
import { getDateAsPerFormat } from "./dateSetter";
import { Chip, Tooltip } from "@mui/material";
import ReusableChip from "../../components/reusableComponents/chipSelector";

const GenerateColumns = (configArray) => {
    return configArray.map((config) => {
        const {
            field,
            headerName,
            type = "text",
            align = "left",
            headerAlign = align,
            flex,
            minWidth,
            renderComponent,
            renderHeaderComponent,
        } = config;

        const column = {
            field,
            headerName,
            align,
            headerAlign,
            flex,
            minWidth,
        };
        if (renderHeaderComponent) {
            column.renderHeader = renderHeaderComponent;
        }

        column.renderCell = (params) => {
            const value = params?.value;
            switch (type) {
                case "text":
                    return <Typography variant="subtitle2" >{value ?? "--"}</Typography>;

                case "date":
                    return <Typography variant="subtitle2" >{getDateAsPerFormat(value, 'dd/MM/yyyy') ?? "--"}</Typography>;

                // case "chip":
                //     return <ReusableChip label={value} />;
                case "chip":
                    const chipStyleMap = {
                        Approved: { color: "#219653", backgroundColor: "#F4FEF6" },
                        Live: { color: "#219653", backgroundColor: "#F4FEF6" },
                        Rejected: { color: "#F14950", backgroundColor: "#FFE3E4" },
                        Pending: { color: "#FDB428", backgroundColor: "#FFF7E9" },
                        Closed: { color: "#787EFF", backgroundColor: "#F5F6FF" }, 
                        "Content-Approved" : { color: "#219653", backgroundColor: "#F4FEF6" },
                        "Not-Avaliable":{color: "#F14950", backgroundColor: "#FFE3E4"},
                        Delivered: { color: "#219653", backgroundColor: "#F4FEF6" },
                        "In Transit": { color: "#FDB428", backgroundColor: "#FFF7E9" },
                        "Delivery Failed": { color: "#F14950", backgroundColor: "#FFE3E4" },
                        "Shipped":{color:'#787EFF', backgroundColor:'#F5F6FF'},
                    };
                    const chipStyles = chipStyleMap[value] || { color: "#6B7280", backgroundColor: "#F0F0F0" };

                    return (
                        <ReusableChip
                            label={value}
                            sx={{
                                color: chipStyles.color,
                                backgroundColor: chipStyles.backgroundColor,
                                // fontWeight: 500,
                                // fontSize: "0.75rem",
                                // height: 28,
                                // px: 1.5,
                                // borderRadius: "6px",
                                // textTransform: "capitalize"
                            }}
                        />
                    );


                // case "tag":
                //     return <TagGroup tags={value}
                //         getLabel={(item) => item.identifier || item.name} />;

                case "tooltip":
                    return value?.extra > 0 ? (
                        <Tooltip title={`${value.main} +${value.extra} more`} >
                            <Typography variant="subtitle2" sx={{ cursor: "pointer", color: "blue" }}>
                                {value.main} +{value.extra}
                            </Typography>
                        </Tooltip>
                    ) : (
                        <Typography variant="subtitle2">{value?.main || "--"}</Typography>
                    );

                case "custom":
                    return renderComponent ? renderComponent(params) : <span />;

                default:
                    return <Typography variant="subtitle2" >{value ?? "--"}</Typography>;
            }
        };

        return column;
    });
};
export default GenerateColumns;